// extracted by mini-css-extract-plugin
export var inlineLink = "_99-0";
export var inlineLinkButton = "_99-1";